export default {
      id: "color_profile_new-usage",
      viewBox: "0 0 151 164",
      url: __webpack_public_path__ + "sprite.svg#color_profile_new",
      toString: function () {
        return this.url;
      }
    }